import { GameObjects, Scene } from "phaser";
import { Language, Messages } from '@core/GUI/Language';
import { Phase, VIDEO_TYPE } from "@core/Logic/Logic";
import { Constants, virtualWheel } from "@core/Utils/Constants";
import { Assets } from "@core/GUI/Utils/Assets";
import { VideoFeedStatic } from "IMAXALiveRoulette/Sources/Video/VideoFeedStatic";
import { Board } from "BaseRoulette/Sources/Board";
import { Track } from "BaseRoulette/Sources/Track";
import { MiscButton } from "@core/GUI/MiscButton";
import { ChatBox } from "@core/GUI/ChatBox";
import { WinReport } from "@core/GUI/WinReport";
import { VideoFeedFLV } from "IMAXALiveRoulette/Sources/Video/VideoFeedFLV";
import { VideoFeedBintu } from "IMAXALiveRoulette/Sources/Video/VideoFeedBintu";
import { ButtonBigSeries, ButtonOrphans, ButtonSmallSeries, ButtonZeroGame } from "@core/Utils/ButtonActions";
import { MenuDialog } from "@core/GUI/Dialogs/MenuDialog";
import { VirtualWheelDisplay, VirtualWheelState } from "IMAXAVirtualRoulette/Sources/Video/VirtualWheelDisplay";
import { LuckyNumberJackpot } from "../../../../BaseRoulette/Sources/Modules/LuckyNumberJackpot";
import { Button } from "@core/GUI/Button";
import { MenuButton } from "@core/GUI/MenuElements/MenuButton";
import { MenuVolumeSettings } from "@core/GUI/MenuElements/MenuVolumeSettings";
import { MenuQualitySettings } from "@core/GUI/MenuElements/MenuQualitySettings";
import { effectsVolume } from "@core/Utils/Constants";
import { MESSAGE_SEVERITY_LEVEL } from "@core/GUI/Dialogs/MessageController";
import { StatisticsWheel } from "BaseRoulette/Sources/StatisticsWheel";
import { Client } from "@core/Client";
import { BalanceDisplay } from "@core/GUI/BalanceDisplay";
import { BetChips } from "@core/GUI/BetChips";
import { WinNumbers } from "../WinNumbers";
import { Bar, ProgressBar } from "@core/GUI/ProgressBar";
import { ConfirmationQuestion } from '@core/GUI/Dialogs/ConfirmationQuestion';

export class TopPanel extends GameObjects.Container {
	public chatBox: ChatBox;
	public moduleContainer: Phaser.GameObjects.Container;
	public virtualWheelDisplay: VirtualWheelDisplay;
	public historyButton: MenuButton;//we disable/enable it
	public WithdrawButton: MenuButton // Reference needed for the pilot seat
	public progressBar: ProgressBar;
	public balanceDisplay;
	public videoFeed: VideoFeedStatic;

	protected contextWasGiven: boolean = false;
	protected staticWidth: number;
	protected staticHeight: number;
	protected portraitMode: boolean = false;
	protected bettingChips;

	protected menuButton: Button;
	protected menuDialog: MenuDialog;
	protected helpButton: Button;
	protected winNumbers: WinNumbers;
	protected gameLogo: GameObjects.Image;

	protected fullscreenButton: MenuButton;//we disable/enable it as we toggle fullscreen
	protected statisticsWheel: StatisticsWheel;

	private playButton: GameObjects.Image;
	private presetButtonsContainer: Phaser.GameObjects.Container;
	private logoutPressed = false;
	private winReport: WinReport;
	private winBackground: Phaser.GameObjects.Image;
	private confrimQuestion: ConfirmationQuestion;

	constructor(scene: Scene, menu: MenuDialog, protected board: Board, protected track: Track) {
		super(scene);
		this.menuDialog = menu;

		this.createLeftItems();
		this.createCenterItems();
		this.createRightItems();
		this.createBottomItems();

		this.OnBoardTypeToggle(true);
		// End of preset buttons top left

		/*====================MODULE LOADER=====================*/
		Client.game.events.addListener(Constants.EVENTS.MODULE_RELOAD, () => { this.ModulesUpdated() });
		this.ModulesUpdated();//update manually on init, some modules may be already loaded like jackpot

		Client.game.events.on("refreshVideoScale", () => this.OnButtonPressedUpdateVideoPositions(), this);
	}

	protected createLeftItems(): void {
		/*================Add menu buttons top left================*/
		this.menuButton = new Button(this.scene, 5, 5, Constants.SPRITESHEET_MENU, "MenuButton_Normal.png", "MenuButton_Hover.png", "MenuButton_Clicked.png", "MenuButton_Disabled.png", "MenuButtonIcon_Menu.png");
		this.menuButton.buttonFunction = () => {
			this.scene.sound.play(Constants.SOUNDS.BUTTON_PRESS_SOFT, { volume: 0.8 * effectsVolume });
			// When we open the menu dialog unzoom the video feed
			Client.game.events.emit(Constants.EVENTS.VIDEO_ZOOM_IN, -1)
			Client.logic.lockAnimations = this.menuDialog.visible = !this.menuDialog.visible;
		};
		this.add(this.menuButton);
		/*=====Add buttons to menu panel======*/
		//history button
		this.historyButton = new MenuButton(this.scene, Language.Get(Messages.MENU_HISTORY), Constants.SPRITESHEET_MENU, "MenuIcon_History.png");
		this.historyButton.buttonFunction = () => {
			Client.logic.OnHistoryButtonClicked();
			if (Client.logic.showStatistics)
				this.toggleStatisticsDisplay(true);

			Client.logic.lockAnimations = this.menuDialog.visible = false;
		};
		this.menuDialog.addButton(this.historyButton);
		//statistics button
		let statisticsButton = new MenuButton(this.scene, Language.Get(Messages.MENU_STATISTICS), Constants.SPRITESHEET_MENU, "MenuIcon_Statistics.png");
		statisticsButton.buttonFunction = () => {
			this.scene.sound.play(Constants.SOUNDS.BUTTON_PRESS_SOFT, { volume: 0.8 * effectsVolume });
			this.toggleStatisticsDisplay();

			Client.logic.lockAnimations = this.menuDialog.visible = false;
		};
		this.menuDialog.addButton(statisticsButton);
		//if mobile (and not iOS) add full screen button
		if (!Client.game.device.os.desktop && !Client.game.device.os.iPad && !Client.game.device.os.iOS && !Client.game.device.os.iPhone) {
			this.fullscreenButton = new MenuButton(this.scene, Language.Get(Messages.MENU_FULLSCREEN), Constants.SPRITESHEET_MENU, "MenuIcon_Fullscreen.png");
			this.fullscreenButton.buttonFunction = () => {
				this.scene.sound.play(Constants.SOUNDS.BUTTON_PRESS_SOFT, { volume: 0.8 * effectsVolume });
				this.scene.scale.startFullscreen();
				Client.logic.lockAnimations = this.menuDialog.visible = false;
			};
			this.menuDialog.addButton(this.fullscreenButton);
		}
		//chat button
		let chatButton = new MenuButton(this.scene, Language.Get(Messages.MENU_CHAT), Constants.SPRITESHEET_MENU, "MenuIcon_Chat.png");
		chatButton.buttonFunction = () => {
			this.scene.sound.play(Constants.SOUNDS.BUTTON_PRESS_SOFT, { volume: 0.8 * effectsVolume });
			if (this.chatBox) {
				if (this.chatBox.closed)
					this.chatBox.openChatBox();
				else
					this.chatBox.closeChatBox();
			}
			Client.logic.lockAnimations = this.menuDialog.visible = false;
		};
		this.menuDialog.addButton(chatButton);
		//volume settings
		let volumeSettings = new MenuVolumeSettings(this.scene, Language.Get(Messages.MENU_VOLUME_SETTINGS), Constants.SPRITESHEET_MENU, "MenuIcon_Volume.png", 2.35, "Menu_SliderImage.png", !virtualWheel);
		this.menuDialog.addButton(volumeSettings);
		//quality settings
		let qualitySettings
		if (!Client.game.device.os.desktop)
			qualitySettings = new MenuQualitySettings(this.scene, Language.Get(Messages.MENU_GRAPHICS_SETTINGS), Constants.SPRITESHEET_MENU, "MenuIcon_Settings.png", 1.80, "Menu_SliderImage.png");
		else
			qualitySettings = new MenuQualitySettings(this.scene, Language.Get(Messages.MENU_GRAPHICS_SETTINGS), Constants.SPRITESHEET_MENU, "MenuIcon_Settings.png", 1.25, "Menu_SliderImage.png");
		this.menuDialog.addButton(qualitySettings);
		//withdraw button if settings tells us to and is not demo
		if (Client.logic.PayoutEnabled && !Client.logic.setup.USER.Demo) {
			this.WithdrawButton = new MenuButton(this.scene, Language.Get(Messages.MENU_WITHDRAW), Constants.SPRITESHEET_MENU, "MenuIcon_Withdraw.png");
			this.WithdrawButton.buttonFunction = () => {
				this.payoutButtonClicked();
				Client.logic.lockAnimations = this.menuDialog.visible = false;
			};
			this.menuDialog.addButton(this.WithdrawButton);
		}
		//logout button if settings tells us to
		if (Client.logic.LogoutSupported) {
			let logoutButton = new MenuButton(this.scene, Language.Get(Messages.MENU_LOGOUT), Constants.SPRITESHEET_MENU, "MenuIcon_Logout.png");
			logoutButton.buttonFunction = () => {
				this.logoutButtonClicked();
				setTimeout(function () {
					Client.logic.lockAnimations = this.menuDialog.visible = true;
				}.bind(this), 110);
			};
			this.menuDialog.addButton(logoutButton);
		}
		/*====================================*/
		this.helpButton = new Button(this.scene, 10 + this.menuButton.buttonBase.displayWidth, 5, Constants.SPRITESHEET_MENU, "MenuButton_Normal.png", "MenuButton_Hover.png", "MenuButton_Clicked.png", "MenuButton_Disabled.png", "MenuButtonIcon_Help.png");
		this.helpButton.buttonFunction = () => {
			this.scene.sound.play(Constants.SOUNDS.BUTTON_PRESS_SOFT, { volume: 0.8 * effectsVolume });
			Client.logic.lockAnimations = this.menuDialog.visible = false;

			if (!Client.logic.showStatistics) {
				if (!virtualWheel && this.videoFeed)
					this.videoFeed.SoftHide()
				else {
					this.virtualWheelDisplay.visible = false;
				}
			} else {
				this.toggleStatisticsDisplay(true);
			}

			if (Client.logic.Phase == Phase.SHOWING_HISTORY_REPLAY) {
				// To prevent video showing up if pressing help button in history replay
				Client.logic.OnHistoryButtonClicked()
			} else Client.game.events.emit(Constants.EVENTS.TOGGLE_HELP);
		};
		this.add(this.helpButton);


		/*================JACKPOT/LOGO CONTAINER================*/
		//jackpot container contains a logo if no jackpot module is loaded
		this.moduleContainer = new GameObjects.Container(this.scene, 0, 0);
		this.add(this.moduleContainer);

		//is removed the moment jackpot module is loaded (if)
		this.gameLogo = new Phaser.GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET_MENU, "Logo_IMAXA.png");
		this.gameLogo.setOrigin(0, 0.5);
		this.gameLogo.alpha = 0.15;
		this.moduleContainer.add(this.gameLogo);

		/*================Preset buttons top left================*/
		let objectsForPresetButtonsContainer = [
			new MiscButton(this.scene, 0, Constants.SPRITESHEET, Assets.Track.Buttons.Wide_Bet.Normal, Assets.Board.Buttons.Zero_Game.Disabled, Assets.PresetPanel.Buttons.Preset_Hover_Button, new ButtonZeroGame(0), false, 18),
			new MiscButton(this.scene, 1, Constants.SPRITESHEET, Assets.Track.Buttons.Wide_Bet.Normal, Assets.Board.Buttons.Big_Series.Disabled, Assets.PresetPanel.Buttons.Preset_Hover_Button, new ButtonBigSeries(1), false, 19),
			new MiscButton(this.scene, 2, Constants.SPRITESHEET, Assets.Track.Buttons.Wide_Bet.Normal, Assets.Board.Buttons.Orphans.Disabled, Assets.PresetPanel.Buttons.Preset_Hover_Button, new ButtonOrphans(2), false, 20),
			new MiscButton(this.scene, 4, Constants.SPRITESHEET, Assets.Track.Buttons.Wide_Bet.Normal, Assets.Board.Buttons.Small_Series.Disabled, Assets.PresetPanel.Buttons.Preset_Hover_Button, new ButtonSmallSeries(4), false, 21),
		]
		this.presetButtonsContainer = new GameObjects.Container(this.scene, 0, 0, objectsForPresetButtonsContainer);

		objectsForPresetButtonsContainer.forEach((object: MiscButton) => {
			this.presetButtonsContainer.add(object.TextElement)
		});

		this.presetButtonsContainer.add(new GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "Zero_Game_Icon.png").setOrigin(0.5));
		this.presetButtonsContainer.add(new GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "Big_Series_Icon.png").setOrigin(0.5));
		this.presetButtonsContainer.add(new GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "Orphans_Icon.png").setOrigin(0.5));
		this.presetButtonsContainer.add(new GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, "Serie_58_Icon.png").setOrigin(0.5));

		this.add(this.presetButtonsContainer);
	}

	protected createCenterItems(): void {
		//-----Statistics wheel
		this.statisticsWheel = new StatisticsWheel(this.scene);
		this.statisticsWheel.visible = false;
		this.add(this.statisticsWheel);

		this.playButton = new GameObjects.Image(this.scene, 0, 0, Constants.SPRITESHEET, Assets.Panel.Play_Button.name);
		this.playButton.setOrigin(0);
		this.playButton.setAlpha(1);
		this.playButton.tint = Constants.PANEL.BUTTON_TINT.NORMAL_TINT;
		this.playButton.setInteractive();
		this.playButton.on("pointerup", () => { this.playButtonClicked() }, this);
		this.playButton.setVisible(false);
		this.add(this.playButton);

		if (!Client.logic.IsSpectator) {
			if (virtualWheel) {
				this.scene.anims.create({
					key: "ballendanim",
					frames: this.scene.anims.generateFrameNames(Constants.ANIMATIONS.BALL_END, {
						start: 0,
						end: 1,
						suffix: ".png"
					}),
					repeat: -1
				})
				this.scene.anims.create({
					key: "balldropanim1",
					frames: this.scene.anims.generateFrameNames(Constants.ANIMATIONS.BALL_SIM01, {
						start: 0,
						end: 152,
						suffix: ".png"
					}),
					repeat: 0
				})
				this.scene.anims.create({
					key: "balldropanim2",
					frames: this.scene.anims.generateFrameNames(Constants.ANIMATIONS.BALL_SIM02, {
						start: 0,
						end: 138,
						suffix: ".png"
					}),
					repeat: 0
				})
				this.scene.anims.create({
					key: "balldropanim3",
					frames: this.scene.anims.generateFrameNames(Constants.ANIMATIONS.BALL_SIM03, {
						start: 0,
						end: 124,
						suffix: ".png"
					}),
					repeat: 0
				})
				this.scene.anims.create({
					key: "balldropanim4",
					frames: this.scene.anims.generateFrameNames(Constants.ANIMATIONS.BALL_SIM04, {
						start: 0,
						end: 118,
						suffix: ".png"
					}),
					repeat: 0
				})

				this.virtualWheelDisplay = new VirtualWheelDisplay(this.scene, this.scene.scale.width / 2 - 150, 0, 300);
			}
			else {
				switch (Client.logic.setup.videoPlayerSettings.type) {
					case VIDEO_TYPE.IMAXA:
						if (Client.game.device.os.iOS) {
							this.videoFeed = new VideoFeedStatic(Constants.VIDEO_FEED.VIDEO_CONTAINER_NAME, this.scene);
							this.add(this.videoFeed);
						}
						else {
							this.videoFeed = new VideoFeedFLV(Constants.VIDEO_FEED.VIDEO_CONTAINER_NAME, this.scene);
							this.add(this.videoFeed);
						}
						break;
					case VIDEO_TYPE.NANO_COSMOS:
						this.videoFeed = new VideoFeedBintu(Constants.VIDEO_FEED.VIDEO_CONTAINER_NAME, this.scene);
						break;
					default:
						break;
				}
			}
		}

		Client.game.events.addListener(Constants.EVENTS.VIDEO_ZOOM_IN, () => {//event fires on waiting for win number
			//if (!mainScene.helpScreen.hidden && Client.logic.BetSum > 0)//if helps are displayed and player has bets on board	, hide them
			//	Client.game.events.emit(Constants.EVENTS.TOGGLE_HELP);
			if (Client.logic.showStatistics)//if statistics are displayed, hide them
				this.toggleStatisticsDisplay();
		})

		this.chatBox = new ChatBox(this.scene)
		this.winReport = new WinReport(this.scene)
		if (!virtualWheel && this.videoFeed)
			this.videoFeed.chatBox = this.chatBox;

	}

	protected createRightItems(): void {
		this.balanceDisplay = new BalanceDisplay(this.scene);
		this.add(this.balanceDisplay);
		Client.game.events.addListener(Constants.EVENTS.PANEL_UPDATE_BALANCE, (effects: boolean = true) => { this.UpdateBalance(effects) });

		this.bettingChips = new BetChips(this.scene, Constants.SPRITESHEET, ["chip1_N.png", "chip1_D.png", "chip2_N.png", "chip2_D.png", "chip3_N.png", "chip3_D.png", "chip4_N.png", "chip4_D.png", "chip5_N.png", "chip5_D.png"], 'bodonistd-bold', 0.75, true, ["chipX_new_5_N_V2.png", "chipX_new_5_D_V2.png", "chipX_multiple_5_N.png"], 0.55, null, 0.8);
		this.add(this.bettingChips);
	}

	protected createBottomItems(): void {
		//-----Add win numbers and its background
		this.winBackground = new Phaser.GameObjects.Image(this.scene, 0, 0, "winNumBackground").setOrigin(0);
		this.add(this.winBackground);

		this.winNumbers = new WinNumbers(this.scene);
		this.add(this.winNumbers);

		//-----Progress bar
		this.progressBar = new ProgressBar(this.scene, this.staticWidth, new Bar(this.scene, this.staticWidth, Constants.PROGRESS_BAR.BAR_COLOR, Constants.PROGRESS_BAR.BACKGROUND_COLOR, 0));
		this.add(this.progressBar);
	}

	public contextGiven() {
		this.contextWasGiven = true;
		this.NotifyVideo();
	}

	set CreditsText(number: number) {
		this.balanceDisplay.SetCreditsText(number);
	}

	set BetText(number: number) {
		this.balanceDisplay.SetBetText(number);

		if (this.WithdrawButton) {
			let withdrawEnabledState = this.WithdrawButton.state;
			this.WithdrawButton.setDisabled(!Client.logic.PayoutEnabled || Client.logic.BetSum > 0);
			if (withdrawEnabledState != this.WithdrawButton.state) {
				this.WithdrawButton.ResizeAndMove(this.WithdrawButton.x, this.WithdrawButton.y, this.WithdrawButton.displayWidth, this.WithdrawButton.displayHeight, this.WithdrawButton.padding);
			}
		}
	}

	setWinText(number: number, jackpotWin: number = 0) {
		this.balanceDisplay.SetWinText(number, jackpotWin);
	}

	ModulesUpdated(): void {
		Client.logic.modules.forEach(module => {
			if (!module.ready && module instanceof LuckyNumberJackpot) {
				module.Assign(this.scene, this.moduleContainer, this.board, this.track);
			}
		});
	}

	UpdateBalance(effects: boolean): void {
		this.balanceDisplay.UpdateBalance(effects);
	}

	/**
	 * Notify video element to start unlocking procedure
	 */
	NotifyVideo(): void {
		if (!virtualWheel && this.videoFeed && Client.game.device.os.iOS) {
			this.videoFeed.TryUnlockingAudioAfterGesture()
		}
	}

	Update(time: number): void {
		Client.logic.modules.forEach(module => {
			if (module.ready) {
				module.Update(time);
			}
		});

		if (this.balanceDisplay) {
			this.balanceDisplay.Update(time);
			this.balanceDisplay.SetBetText(Client.logic.BetSum);
			this.balanceDisplay.SetWinText(Client.logic.CurrentWin, Client.logic.jackpotWin);
		}

		if (this.progressBar) this.progressBar.Update(time);
		if (this.historyButton) this.historyButton.setDisabled(!Client.logic.canHistoryBeViewed);
	}

	UpdatePositions(width, height, portraitMode, staticWidth, staticHeight): void {
		this.staticWidth = staticWidth;
		this.staticHeight = staticHeight;
		this.width = width;
		this.height = height;
		this.portraitMode = portraitMode;

		let heightChunk = Math.min(height / 10, this.board.boardButtons[5].displayHeight * 0.55);

		//--------Win history
		this.winNumbers.UpdatePosition(width, heightChunk * 1.5);
		this.winNumbers.setPosition(0, height - 2.5 * heightChunk);

		this.winBackground.setPosition(this.winNumbers.x, this.winNumbers.y);
		this.winBackground.setDisplaySize(width, heightChunk * 1.5);

		//--------Time bar
		this.progressBar.UpdatePositions(width, heightChunk);
		this.progressBar.setPosition(0, height - heightChunk);

		let leftoverHeight = height - (heightChunk * 2.5);
		let videoWidthTaken = Math.min(leftoverHeight * Constants.VIDEO_FEED.ASPECT_RATIO, width / 2);
		let sideSpace = (width - videoWidthTaken) / 2;
		let padding = width * Constants.PANEL.MARGIN;

		//----------center holds video and statistics wheel--------------------------------------------------------------
		if (virtualWheel || this.videoFeed)
			this.UpdateVideoFeedPositions(staticWidth, staticHeight, portraitMode)

		if (this.chatBox && !Client.logic.IsSpectator) {
			this.chatBox.DOM.setVisible(true);
			this.chatBox.EnableInputBox();

			this.chatBox.SetPosition(0, 0, portraitMode);
		}

		if (this.board.statisticsAreDisplayed) {
			this.board.toggleNumberStatistics(true);
		}

		if (this.track.statisticsAreDisplayed) {
			this.track.toggleNumberStatistics(true);
		}

		if (this.statisticsWheel) {
			this.statisticsWheel.setPosition(width / 2, leftoverHeight / 2);
			this.statisticsWheel.RedrawCircleBars(videoWidthTaken, leftoverHeight);
		}

		if (this.confrimQuestion) {
			this.confrimQuestion.OnResize(this.staticWidth, this.staticHeight, this.portraitMode);
		}

		//----------on the right side we have balance on top , betting chips on bottom-----------------------------------
		//if slot we also have exit button on the right side next to balance stuff
		if (Client.slot) {
			this.balanceDisplay.UpdatePosition((sideSpace * 0.75) - 60, (leftoverHeight / 3) * 2 - padding * 2);
			this.balanceDisplay.setPosition((width - (sideSpace * 0.75)) - 60, 0);
		}
		else {
			this.balanceDisplay.UpdatePosition(sideSpace, (leftoverHeight / 3) * 2 - padding * 2);
			this.balanceDisplay.setPosition(width - sideSpace, 0);
		}

		this.bettingChips.UpdatePosition(sideSpace, leftoverHeight / 3);
		this.bettingChips.setPosition(width - sideSpace, (leftoverHeight / 3) * 2);

		//----------left side has menu buttons on top, module container in middle and preset buttons on bottom-----------
		//----------menu stuff----------
		if (staticHeight) {
			let menuWidth: number = 0; //width of menu popup
			let buttonHeight: number = 0; //height of buttons in menu popup
			let buttonSize = Math.min((heightChunk * 1.75), sideSpace / 5);//height of menu button and help button

			if (Client.game.device.os.desktop) {
				menuWidth = Math.min(this.board.displayWidth / 2.5, sideSpace);
				buttonHeight = Math.min(leftoverHeight / 3, (staticHeight - buttonSize) / (this.menuDialog.buttons.length + 3.6));
			} else {
				if (this.fullscreenButton) {
					if (this.scene.scale.isFullscreen) {
						this.fullscreenButton.setDisabled(true);
					} else {
						this.fullscreenButton.setDisabled(false);
					}
				}
				menuWidth = sideSpace;
				buttonHeight = (staticHeight - buttonSize) / (this.menuDialog.buttons.length + 4.15);
			}

			//dont allow user to even click history button if he cannot enter
			this.historyButton.setDisabled(!Client.logic.canHistoryBeViewed);

			if (this.WithdrawButton)
				this.WithdrawButton.setDisabled(!Client.logic.PayoutEnabled || Client.logic.BetSum > 0);

			this.menuButton.ResizeAndMove(padding, padding, this.menuButton.buttonBase.frame.width * (buttonSize / this.menuButton.buttonBase.frame.height), buttonSize);
			this.menuDialog.ResizeAndMove(padding, this.menuButton.y + this.menuButton.displayHeight + padding, menuWidth - padding * 2, buttonHeight, padding, staticWidth, staticHeight);
			if (portraitMode)
				this.menuDialog.y -= staticHeight;
			this.helpButton.ResizeAndMove((padding * 2) + this.menuButton.width, this.menuButton.y, this.menuButton.width, this.menuButton.height);
		}

		//--Preset buttons-------- < all of this needs a rewrite
		let presetResize: number = 1;
		if (Client.logic.modules.length > 0) {
			presetResize = 0.8;
		}
		this.presetButtonsContainer.list.forEach((child, i) => {
			if (i < 4) {
				(child as MiscButton).setDisplaySize(sideSpace / 4 - padding, (leftoverHeight / 3) * presetResize);
				(child as MiscButton).setScale(Math.min((child as MiscButton).scaleX, (child as MiscButton).scaleY));
				(child as MiscButton).x = i * ((child as Phaser.GameObjects.Image).displayWidth + padding);
			}
		});

		this.presetButtonsContainer.height = (this.presetButtonsContainer.list[0] as MiscButton).displayHeight;
		this.presetButtonsContainer.width = sideSpace;
		this.presetButtonsContainer.y = this.winNumbers.y - this.presetButtonsContainer.height;
		this.presetButtonsContainer.x = padding;

		let bewton = (this.presetButtonsContainer.list[0] as MiscButton);
		(this.presetButtonsContainer.list[8] as Phaser.GameObjects.Image).setScale((this.presetButtonsContainer.list[0] as MiscButton).scale).setPosition((this.presetButtonsContainer.list[0] as MiscButton).x + bewton.displayWidth / 2, (this.presetButtonsContainer.list[0] as MiscButton).y + bewton.displayHeight * 0.8);
		(this.presetButtonsContainer.list[9] as Phaser.GameObjects.Image).setScale((this.presetButtonsContainer.list[0] as MiscButton).scale).setPosition((this.presetButtonsContainer.list[1] as MiscButton).x + bewton.displayWidth / 2, (this.presetButtonsContainer.list[1] as MiscButton).y + bewton.displayHeight * 0.8);
		(this.presetButtonsContainer.list[10] as Phaser.GameObjects.Image).setScale((this.presetButtonsContainer.list[0] as MiscButton).scale).setPosition((this.presetButtonsContainer.list[2] as MiscButton).x + bewton.displayWidth / 2, (this.presetButtonsContainer.list[2] as MiscButton).y + bewton.displayHeight * 0.8);
		(this.presetButtonsContainer.list[11] as Phaser.GameObjects.Image).setScale((this.presetButtonsContainer.list[0] as MiscButton).scale).setPosition((this.presetButtonsContainer.list[3] as MiscButton).x + bewton.displayWidth / 2, (this.presetButtonsContainer.list[3] as MiscButton).y + bewton.displayHeight * 0.8);

		(this.presetButtonsContainer.list[0] as MiscButton).AlignText(0.5, Client.logic.IsBoard ? 0.35 : 0.5);
		(this.presetButtonsContainer.list[1] as MiscButton).AlignText(0.5, Client.logic.IsBoard ? 0.35 : 0.5);
		(this.presetButtonsContainer.list[2] as MiscButton).AlignText(0.5, Client.logic.IsBoard ? 0.45 : 0.5);
		(this.presetButtonsContainer.list[3] as MiscButton).AlignText(0.5, Client.logic.IsBoard ? 0.35 : 0.5);

		//----------module container by default holds imaxa logo, otherwise holds jackpot or minigames----------
		this.moduleContainer.setPosition(padding, this.menuButton.displayHeight + padding);
		this.moduleContainer.setSize(sideSpace - 2 * padding, leftoverHeight - (this.presetButtonsContainer.height + this.menuButton.displayHeight + 2 * padding));

		if (Client.logic.modules.length > 0) {
			Client.logic.modules.forEach(module => {
				module.UpdatePosition();
			});

			if (this.gameLogo && this.gameLogo.visible) {
				this.gameLogo.visible = false;
				this.moduleContainer.remove(this.gameLogo);
			}
		} else {//if there are no modules draw logo
			this.gameLogo.setPosition(0, this.moduleContainer.height / 2);
			this.gameLogo.setDisplaySize(this.moduleContainer.width, this.moduleContainer.height);
			this.gameLogo.setScale(Math.min(this.gameLogo.scaleX, this.gameLogo.scaleY));
		}

		this.updateVideoVisibility();

		this.bringToTop(this.winNumbers);
	}

	OnButtonPressedUpdateVideoPositions(): void {
		if (!virtualWheel)
			this.UpdateVideoFeedPositions(this.staticWidth, this.staticHeight, this.portraitMode);
	}

	//TODO: Video related things need a serious fucking rewrite its atrocious, beware all yee who enter here
	UpdateVideoFeedPositions(staticWidth, staticHeight, portraitMode): void {
		//We need the starting X in scale.

		let heightChunk = Math.min(this.height / 10, this.board.boardButtons[5].displayHeight * 0.55);
		let availHeight = (this.height - (heightChunk * 2.5));
		let availWidth = Math.min(availHeight * Constants.VIDEO_FEED.ASPECT_RATIO, this.width / 2);
		let startX = (this.width - availWidth) / 2 - (2 * this.width * Constants.PANEL.MARGIN);

		if (virtualWheel) {
			if (this.portraitMode)
				this.virtualWheelDisplay.UpdatePosition(this.width / 2 - Math.min(availHeight, availWidth) / 2, -staticHeight, Math.min(availHeight, availWidth), this.width / 20, portraitMode, staticWidth, staticHeight);
			else
				this.virtualWheelDisplay.UpdatePosition(this.width / 2 - Math.min(availHeight, availWidth) / 2, 0, Math.min(availHeight, availWidth), this.width / 20, portraitMode, staticWidth, staticHeight);
		}
		else {
			this.videoFeed.UpdatePositions(new Phaser.Geom.Rectangle(startX, 0, availWidth, availHeight), staticWidth, staticHeight, this.portraitMode)
			setTimeout(() => this.videoFeed.UpdatePositions(new Phaser.Geom.Rectangle(startX, 0, availWidth, availHeight), staticWidth, staticHeight, this.portraitMode), 300)
		}
	}

	protected updateVideoVisibility(): void {
		/**
		 * SHOW VIDEO ALWAYS AFTER EVERYTHING ELSE WAS ALREADY ALIGNED
		 * UNLESS SHOWING HISTORIC STATE OR WHILE IN DISCONNECTED STATE
		 */

		if (!this.contextWasGiven || Client.logic.Phase == Phase.SHOWING_HISTORY_REPLAY || Client.logic.Phase == Phase.ERROR_OR_DISCONNECTED || (this.statisticsWheel && this.statisticsWheel.visible)) {
			if (this.videoFeed)
				this.videoFeed.Hide()
			else if (virtualWheel) {
				this.virtualWheelDisplay.visible = false;
			}
		} else {
			if (!virtualWheel && this.videoFeed && !Client.logic.lockBetting)
				this.videoFeed.Show()
			else if (virtualWheel && !Client.logic.lockBetting) {
				this.virtualWheelDisplay.visible = true;
			}

			if (this.playButton)
				this.playButton.tint = Constants.PANEL.BUTTON_TINT.SELECTED_TINT;

			if (Client.logic.showStatistics)
				this.toggleStatisticsDisplay();
		}
	}

	private playButtonClicked(): void {
		if (virtualWheel)
			return;

		if (Client.logic.Phase == Phase.ERROR_OR_DISCONNECTED) {
			this.videoFeed.Hide()
			return
		}
		this.videoFeed.Toggle()
		if (this.videoFeed.Visible) {
			this.OnButtonPressedUpdateVideoPositions()
			this.playButton.tint = Constants.PANEL.BUTTON_TINT.SELECTED_TINT;
		}
		else
			this.playButton.tint = Constants.PANEL.BUTTON_TINT.NORMAL_TINT;
	}

	protected toggleStatisticsDisplay(ignoreVideos: boolean = false): void {
		Client.logic.showStatistics = !Client.logic.showStatistics;

		if (this.statisticsWheel) {
			this.statisticsWheel.RedrawCircleBars(Math.min(this.height * Constants.VIDEO_FEED.ASPECT_RATIO, this.width / 2), this.height - (this.winNumbers.height + this.progressBar.height));
			this.statisticsWheel.visible = !this.statisticsWheel.visible;
		}

		if (!ignoreVideos) {
			if (virtualWheel) {
				this.virtualWheelDisplay.Visibility(!Client.logic.showStatistics);
			}
			else if (this.videoFeed) {
				if (this.videoFeed.Visible && Client.logic.showStatistics)
					this.videoFeed.SoftHide();
				else
					this.videoFeed.Show();
			}
		}
		if (this.board)
			this.board.toggleNumberStatistics();
		if (this.track)
			this.track.toggleNumberStatistics();
	}

	public payoutButtonClicked(): void {
		if (Client.logic.Credits == 0)
			return;

		if (this.WithdrawButton)
			this.WithdrawButton.setDisabled(!Client.logic.PayoutEnabled);

		if (!Client.logic.PayoutEnabled)
			return;

		this.scene.sound.play(Constants.SOUNDS.BUTTON_PRESS_SOFT, { volume: 0.8 * effectsVolume });
		//IF USER CANCELLED THE PAYOUT REQUEST SEND NULL AS PASSWORD TO THE SERVER
		if (Client.logic.AuthenticationRequired) {
			Client.logic.OnRequestPayoutClicked()
		} else {
			Client.logic.lockAnimations = true;
			this.confrimQuestion = new ConfirmationQuestion(this.scene, (answer) => {
				console.log("USER CLICKED " + answer);
				if (answer) {
					Client.logic.OnRequestPayoutClicked();
				}
				else {
					//do nothing just remove the dialog
				}
				//remove question dialogue
				this.confrimQuestion.visible = false;
				this.scene.children.remove(this.confrimQuestion);
				this.confrimQuestion.destroy();
				this.confrimQuestion = null;
				if (this.videoFeed)
					this.ShowVideo();
				Client.logic.lockAnimations = false;
			}, this.staticWidth, this.staticHeight, this.portraitMode, Language.Get(Messages.PAYOUT_REQUEST_ARE_YOU_SURE) + ' ' + Language.InternationalNumberFormat.format(Client.logic.BalanceManager.CreditToMoney(Client.logic.BalanceManager.GetCredit())) + '?', Constants.QUESTION_STYLE_FONT);
			this.scene.children.add(this.confrimQuestion);
			this.confrimQuestion.OnResize(this.staticWidth, this.staticHeight, this.portraitMode);
		}
	}

	public logoutButtonClicked(): void {
		this.scene.sound.play(Constants.SOUNDS.BUTTON_PRESS_SOFT, { volume: 0.8 * effectsVolume });
		if (!this.logoutPressed) {
			if (Client.logic.Phase == Phase.SHOWING_HISTORY_REPLAY) return
			if (virtualWheel) {
				if (this.virtualWheelDisplay.currentWheelState != VirtualWheelState.IDLE) {
					Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.CANNOT_LOGOUT_ACTIVE_GAME), MESSAGE_SEVERITY_LEVEL.WARNING)
					return
				}
				Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.PRESS_LOGOUT_AGAIN_TO_LOGOUT), MESSAGE_SEVERITY_LEVEL.NOTICE)
				this.logoutPressed = true
				setTimeout(() => {
					this.logoutPressed = false
				}, Constants.MESSAGE_BOX.TWEEN.TWEEN_DELAY + Constants.MESSAGE_BOX.TWEEN.TWEEN_DURATION, this);
				return
			}
			if (!Client.logic.IsEmpty) {
				Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.CANNOT_LOGOUT_ACTIVE_GAME), MESSAGE_SEVERITY_LEVEL.WARNING)
				return
			}
			Client.game.events.emit(Constants.EVENTS.SHOW_MESSAGE_BOX, Language.Get(Messages.PRESS_LOGOUT_AGAIN_TO_LOGOUT), MESSAGE_SEVERITY_LEVEL.NOTICE)
			this.logoutPressed = true
			setTimeout(() => {
				this.logoutPressed = false
			}, Constants.MESSAGE_BOX.TWEEN.TWEEN_DELAY + Constants.MESSAGE_BOX.TWEEN.TWEEN_DURATION, this);
		} else {
			Client.logic.OnLogoutClicked(() => {
				if (this.chatBox)
					this.chatBox.DOM.setVisible(false)
			})
		}
	}

	HideVideo(): void {
		if (virtualWheel) {
			this.virtualWheelDisplay.visible = false;
			return
		}
		else if (!this.videoFeed) {
			return
		}
		this.videoFeed.Hide(true);
		if (this.playButton)
			this.playButton.tint = Constants.PANEL.BUTTON_TINT.NORMAL_TINT;
	}

	ShowVideo(): void {
		if (virtualWheel) {
			this.virtualWheelDisplay.visible = true;
			return;
		}
		else if (this.videoFeed && !this.videoFeed.visible) {
			this.videoFeed.Show();
			if (this.playButton)
				this.playButton.tint = Constants.PANEL.BUTTON_TINT.SELECTED_TINT;
		}
	}

	OnBoardTypeToggle(_isBoard: boolean): void {
		if (!this.presetButtonsContainer)
			return;

		if (_isBoard) {
			//set board misc buttons
			(this.presetButtonsContainer.list[0] as MiscButton).SetTextures(Assets.Track.Buttons.Wide_Bet.Normal, Assets.Board.Buttons.Zero_Game.Disabled, Assets.PresetPanel.Buttons.Preset_Hover_Button);
			(this.presetButtonsContainer.list[1] as MiscButton).SetTextures(Assets.Track.Buttons.Wide_Bet.Normal, Assets.Board.Buttons.Big_Series.Disabled, Assets.PresetPanel.Buttons.Preset_Hover_Button);
			(this.presetButtonsContainer.list[2] as MiscButton).SetTextures(Assets.Track.Buttons.Wide_Bet.Normal, Assets.Board.Buttons.Orphans.Disabled, Assets.PresetPanel.Buttons.Preset_Hover_Button);
			(this.presetButtonsContainer.list[3] as MiscButton).SetTextures(Assets.Track.Buttons.Wide_Bet.Normal, Assets.Board.Buttons.Small_Series.Disabled, Assets.PresetPanel.Buttons.Preset_Hover_Button);
			(this.presetButtonsContainer.list[0] as MiscButton).IsRadio = false;
			(this.presetButtonsContainer.list[1] as MiscButton).IsRadio = false;
			(this.presetButtonsContainer.list[2] as MiscButton).IsRadio = false;
			(this.presetButtonsContainer.list[3] as MiscButton).IsRadio = false;
			(this.presetButtonsContainer.list[0] as MiscButton).TextElement.text = Language.Get(Messages.ZERO_GAME);
			(this.presetButtonsContainer.list[0] as MiscButton).TextElement.setStyle(Constants.PRESETS_PANEL.BOARD_TEXTS_STYLE_FONT);
			(this.presetButtonsContainer.list[1] as MiscButton).TextElement.text = Language.Get(Messages.BIG_SERIES);
			(this.presetButtonsContainer.list[1] as MiscButton).TextElement.setStyle(Constants.PRESETS_PANEL.BOARD_TEXTS_STYLE_FONT);
			(this.presetButtonsContainer.list[2] as MiscButton).TextElement.text = Language.Get(Messages.ORPHANS);
			(this.presetButtonsContainer.list[2] as MiscButton).TextElement.setStyle(Constants.PRESETS_PANEL.BOARD_TEXTS_STYLE_FONT);
			(this.presetButtonsContainer.list[3] as MiscButton).TextElement.text = Language.Get(Messages.SERIE_58);
			(this.presetButtonsContainer.list[3] as MiscButton).TextElement.setStyle(Constants.PRESETS_PANEL.BOARD_TEXTS_STYLE_FONT);

			// Bring icons to the top
			this.bringToTop(this.presetButtonsContainer[8]);
			this.bringToTop(this.presetButtonsContainer[9]);
			this.bringToTop(this.presetButtonsContainer[10]);
			this.bringToTop(this.presetButtonsContainer[11]);

			// Bringing to top directly on Panel container will not work
			// Must be brought to top via presetButtonsContainer however
			// Doing that will shift the elements and break all the logic
			(this.presetButtonsContainer.list[8] as Phaser.GameObjects.Image).setVisible(true);
			(this.presetButtonsContainer.list[9] as Phaser.GameObjects.Image).setVisible(true);
			(this.presetButtonsContainer.list[10] as Phaser.GameObjects.Image).setVisible(true);
			(this.presetButtonsContainer.list[11] as Phaser.GameObjects.Image).setVisible(true);
		} else {
			//set track wide bets
			(this.presetButtonsContainer.list[0] as MiscButton).SetTextures(Assets.Track.Buttons.Wide_Bet.Normal, Assets.Track.Buttons.Wide_Bet.Disabled, Assets.Track.Buttons.Wide_Bet.Hover);
			(this.presetButtonsContainer.list[1] as MiscButton).SetTextures(Assets.Track.Buttons.Wide_Bet.Normal, Assets.Track.Buttons.Wide_Bet.Disabled, Assets.Track.Buttons.Wide_Bet.Hover);
			(this.presetButtonsContainer.list[2] as MiscButton).SetTextures(Assets.Track.Buttons.Wide_Bet.Normal, Assets.Track.Buttons.Wide_Bet.Disabled, Assets.Track.Buttons.Wide_Bet.Hover);
			(this.presetButtonsContainer.list[3] as MiscButton).SetTextures(Assets.Track.Buttons.Wide_Bet.Normal, Assets.Track.Buttons.Wide_Bet.Disabled, Assets.Track.Buttons.Wide_Bet.Hover);
			(this.presetButtonsContainer.list[0] as MiscButton).IsRadio = true;
			(this.presetButtonsContainer.list[1] as MiscButton).IsRadio = true;
			(this.presetButtonsContainer.list[2] as MiscButton).IsRadio = true;
			(this.presetButtonsContainer.list[3] as MiscButton).IsRadio = true;
			this.bringToTop((this.presetButtonsContainer.list[0] as MiscButton));
			this.bringToTop((this.presetButtonsContainer.list[1] as MiscButton));
			this.bringToTop((this.presetButtonsContainer.list[2] as MiscButton));
			this.bringToTop((this.presetButtonsContainer.list[3] as MiscButton));
			(this.presetButtonsContainer.list[0] as MiscButton).TextElement.text = "+0";
			(this.presetButtonsContainer.list[0] as MiscButton).TextElement.setStyle(Constants.PRESETS_PANEL.TRACK_TEXTS_STYLE_FONT);
			(this.presetButtonsContainer.list[1] as MiscButton).TextElement.text = "+1";
			(this.presetButtonsContainer.list[1] as MiscButton).TextElement.setStyle(Constants.PRESETS_PANEL.TRACK_TEXTS_STYLE_FONT);
			(this.presetButtonsContainer.list[2] as MiscButton).TextElement.text = "+2";
			(this.presetButtonsContainer.list[2] as MiscButton).TextElement.setStyle(Constants.PRESETS_PANEL.TRACK_TEXTS_STYLE_FONT);
			(this.presetButtonsContainer.list[3] as MiscButton).TextElement.text = "+4";
			(this.presetButtonsContainer.list[3] as MiscButton).TextElement.setStyle(Constants.PRESETS_PANEL.TRACK_TEXTS_STYLE_FONT);
			this.bringToTop((this.presetButtonsContainer.list[0] as MiscButton).TextElement);
			this.bringToTop((this.presetButtonsContainer.list[1] as MiscButton).TextElement);
			this.bringToTop((this.presetButtonsContainer.list[2] as MiscButton).TextElement);
			this.bringToTop((this.presetButtonsContainer.list[3] as MiscButton).TextElement);

			(this.presetButtonsContainer.list[8] as Phaser.GameObjects.Image).setVisible(false);
			(this.presetButtonsContainer.list[9] as Phaser.GameObjects.Image).setVisible(false);
			(this.presetButtonsContainer.list[10] as Phaser.GameObjects.Image).setVisible(false);
			(this.presetButtonsContainer.list[11] as Phaser.GameObjects.Image).setVisible(false);

			(this.presetButtonsContainer.list[0] as MiscButton).SetHover();
			Client.game.events.emit(Constants.EVENTS.TOGGLE_RADIOBUTTONS, 0);
			Client.game.events.emit(Constants.EVENTS.SET_WIDE_BET, 0);
		}

		(this.presetButtonsContainer.list[0] as MiscButton).AlignText(0.5, Client.logic.IsBoard ? 0.35 : 0.5);
		(this.presetButtonsContainer.list[1] as MiscButton).AlignText(0.5, Client.logic.IsBoard ? 0.35 : 0.5);
		(this.presetButtonsContainer.list[2] as MiscButton).AlignText(0.5, Client.logic.IsBoard ? 0.45 : 0.5);
		(this.presetButtonsContainer.list[3] as MiscButton).AlignText(0.5, Client.logic.IsBoard ? 0.35 : 0.5);

		Client.logic.modules.forEach(module => {
			module.UpdatePosition();
		});
	}
}